module.exports = __webpack_public_path__ + "img/meter.a31bf773.svg";